<template>
  <div
    class="job-architecture-add-row"
    :class="{
      'job-architecture-add-row--group': variant === 'group',
      'job-architecture-add-row--family': variant === 'family',
    }"
    @click.stop
  >
    <DpplNewButton
      variant="text"
      color="brandPrimary"
      height="32"
      min-width="0"
      :class="variantConfig.buttonClass"
      @click="handleClick"
    >
      {{ variantConfig.label }}
    </DpplNewButton>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import DpplNewButton from '@/components/datapeople/DpplNewButton.vue';
import { useJobArchitecture } from '@/stores/jobArchitecture/jobArchitecture';

const VARIANTS = {
  family: {
    label: '+ Add Family',
    buttonClass: 'job-architecture-add-row-trigger text-h3 px-2',
  },
  group: {
    label: '+ Add Family Group',
    buttonClass: 'job-architecture-add-row-trigger text-h2 px-2',
  },
};

const props = defineProps({
  variant: {
    type: String,
    required: true,
  },
  groupUlid: {
    type: String,
    default: null,
  },
});

const { openRowAction } = useJobArchitecture();

const variantConfig = computed(() => VARIANTS[props.variant] ?? VARIANTS.family);

const handleClick = () => {
  if (props.variant === 'group') {
    openRowAction('add-group', {});
    return;
  }

  openRowAction('add-family', { groupUlid: props.groupUlid });
};
</script>

<style scoped lang="less">
.job-architecture-add-row {
  width: 400px;
  max-width: 100%;
}

.job-architecture-add-row-trigger {
  justify-content: flex-start;
}

.job-architecture-add-row--family {
  margin-left: -8px;
}

.job-architecture-add-row--group {
  padding: 12px 16px;
}
</style>
